export enum BlockType {
  Start = 1000,
  Else = 0,
  Response = 1,
  UserInput = 2,
  Goto = 3,
  Button = 4,
  VideoBlock = 5,
  VideoGoto = 6,
  VideoButton = 7,
  VideoLink = 8,
  PassToAi = 9,
  Variable = 10,
  TextLink = 11,
  HTTP = 12,
  Condition = 13,
  ElseCondition = 14,
  OverrideVariable = 15,
  CreateVariable = 16,
  Lead = 17,
  Media = 18,
  Attachment = 19,
  EndOFConversation = 20,
  Delay = 21,
  MakeWebHook = 22,
  NotifyMeByEmail = 23,
  ReceiveAttachment = 24,
  SUMLogin = 25,
  SUMLogout = 26,
  InjectTemplate = 27,
  GetUserInfo = 28,
  CheckUserExists = 29,
  UserLoginForm = 30,
  SwitchToChatbot = 31,
  SpeechRecording = 32,
  AskToAI = 33,
  SummarizeConversation = 34,
  JsCode = 35,
}

export enum ButtonType {
  Message = 0,
  Goto = 1,
}
